export const APP_CATEGORIES = [
  "art_design",
  "auto_vehicles",
  "beauty",
  "books_reference",
  "reference",
  "business",
  "comics",
  "communication",
  "dating",
  "education",
  "entertainment",
  "events",
  "finance",
  "food_drink",
  "games",
  "health_fitness",
  "house_home",
  "lifestyle",
  "maps_navigation",
  "medical",
  "music_audio",
  "news_magazines",
  "parenting",
  "personalization",
  "photo_video",
  "productivity",
  "shopping",
  "social",
  "sports",
  "tools",
  "travel",
  "utilities",
  "weather",
] as const;

export const formatAppCategoryLabel = (category: string) =>
  String(category || "")
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
